class ReviewQuestionFullModalController {

    constructor(result, categoryInfo) {

        this.result = result;
        this.categoryInfo = categoryInfo;

        this.template = Handlebars.compile($("#reviewQuestionFullModal").html());
        this.menuTemplate = Handlebars.compile($("#fullModalMenu").html());

        this.currentQuestionIndex = 0;
        this.current_question_is_correct = false;
        this.numQuestions = result.questions.length;
        this.question_response_max_time = world.question_response_max_time / 1000;
        this.completeRequest = this.createCompleteRequest();

        var that = this;

        $(document).off('click','#reviewQuestion-sendBtn');
        $(document).on("click", '#reviewQuestion-sendBtn', function() {
            that.showRateModal(that.result.questions[that.currentQuestionIndex].question);
        });

        $(document).off("click", '#rateAcceptBtn');
        $(document).on("click", '#rateAcceptBtn', function() {
            $("#modalContainer").modal('hide').empty();
            that.currentQuestionIndex++;
            api.sendCompleteReview(that.completeRequest);
        });

        // $(document).off('click','#review-question-result-modal .modal-close-btn');
        // $(document).on("click", '#review-question-result-modal .modal-close-btn', function() {
        //     $("#modalContainer").modal('hide').empty();
        //      api.getQuestionStats(world.token,true);
        // });

    };

    createCompleteRequest() {
        var completeRequest = {};
        completeRequest.questions = [];
        completeRequest.world_token = world.token;
        return completeRequest;
    };

    open() {

        ga('send', 'pageview', analytics.GA_SCREEN_RIGHT_QUESTION);
        this.showNextQuestion();

    }

    close() {

        api.getQuestionStats(world.token, true);

    }

    showNextQuestion() {

        this.completeRequest = this.createCompleteRequest();

        if (this.currentQuestionIndex < this.numQuestions) {
            let that = this;
            setTimeout(function() { that.drawQuestion(); }, 500);
        } else {
            this.close();
        }

    };

    drawQuestion() {

        let question = this.result.questions[this.currentQuestionIndex];
        let category = question.question.category;

        let context = question;

        if (this.currentQuestionIndex > 0) {
            baseController.closeSimpleMenu();
        }

        baseController.resetStackableOrder();
        baseController.stackSimpleMenu({title: category.name, icon: 'back', rightIcon: category.icon, bgColor: category.color}, this.menuTemplate);
        baseController.stackSimpleContent(this.template, context);

        $('.answerBtn').shuffle();
        this.manageAnswer();

    };

    createResponseQuestionObject(dataQuestion, is_correct, review_calification){

        var question = {};
        question.id = dataQuestion.id;
        question.is_correct = is_correct;
        question.review_calification = review_calification;

        this.completeRequest.questions.push(question);
    };

    manageAnswer(){

        var that=this;

        let currentQuestion = this.result.questions[this.currentQuestionIndex].question;

        $(document).off("click", '.answerBtn');
        $(document).one("click", '.answerBtn', function() {

            var userAnswer = $(this).attr('data-answer');
            var correctAnswer = currentQuestion.correct_answer;

            that.current_question_is_correct = (correctAnswer == userAnswer);
            if (!that.current_question_is_correct) $(this).addClass('red-btn');
            $('*[data-answer="'+correctAnswer+'"]').addClass('green-btn');
            $('#reviewQuestion-sendBtn').removeClass('disabled');

        });

    };

    showRateModal(question) {
        var that = this;

        var template = Handlebars.compile($("#rateQuestionModal").html());
        var context = {
            question: question.title,
            points: world.question_review_points,
            smile1Icon: customIcons["RATE_SMILE_1"],
            smile2Icon: customIcons["RATE_SMILE_2"],
            smile3Icon: customIcons["RATE_SMILE_3"],
            smile4Icon: customIcons["RATE_SMILE_4"],
            smile5Icon: customIcons["RATE_SMILE_5"],
        };

        $("#modalContainer").html(template(context)).modal('show');

        $(".rateQuestionIcon").click(function(e){
            e.preventDefault();
            let ratingPoints = $(this).data("rating");

            $("#rateYo").css("pointer-events", "none").css("cursor", "default");

            $("#rateYo").find('img').each(function (i, child) {
                // $(child).attr('src', '/images/smilie0' + (i+1) + '-red.png');
                if (i+1 !== ratingPoints) {
                    $(child).css('opacity', '0.5');
                }
            });

            let points = (question.review_calification + ratingPoints)/2;
            $('#rate-points').text(points);
            $('#progress-point-bar').css('width', ((points*75)/5) + '%');
            $('#rate-points').removeClass('hidden');
            $('#progress-point-bar').removeClass('hidden');
            $('#progress-point-bar-background').removeClass('hidden');

            // Enable accept button
            $('#rateAcceptBtn').removeClass('disabled');
            // Show points
            $('#rateQuestionPointsSpan').removeClass('hidden');
            // Show icon of the selected value
            // $('#rateSvgIcon-' + ratingPoints).css('visibility','visible');

            that.createResponseQuestionObject(
                that.result.questions[that.currentQuestionIndex].question,
                that.current_question_is_correct,
                ratingPoints);
        });

        // $("#rateYo").rateYo({
        //     starWidth: "80px",
        //     spacing: "15px",
        //     label1: Translator.trans("TR_MALA"),
        //     label2: Translator.trans("TR_REGULAR"),
        //     label3: Translator.trans("TR_NORMAL"),
        //     label4: Translator.trans("TR_BUENA"),
        //     label5: Translator.trans("TR_GENIAL"),
        //     fullStar: true
        // }).on("rateyo.set", function (e, data) {
        //     // Enable accept button
        //     $('#rateAcceptBtn').removeClass('disabled');
        //     // Show points
        //     $('#rateQuestionPointsSpan').removeClass('hidden');
        //     // Show icon of the selected value
        //     $('.rate-svg-icon').css('visibility','hidden');
        //     $('#rateSvgIcon-' + data.rating).css('visibility','visible');
        //     // Fill rate bar
        //     $('.jq-ry-rated-group svg').css('background-color','#409432');
        //     var currentRate = (question.review_calification * 100 / 5) - 1;
        //     $('.jq-ry-rated-group').css('width', currentRate +'%');
        //     // Disable changed rate
        //     $(this).rateYo("option", "ratedFill", '#0b6418');
        //     $(this).rateYo("option", "readOnly", true);
        //
        //     that.createResponseQuestionObject(
        //         that.result.questions[that.currentQuestionIndex].question,
        //         that.current_question_is_correct,
        //         data.rating);
        // });
    }

    showResultModal(result){

        let points = result.user_points;
        let numQuestionsAnswered = this.completeRequest.questions.length;
        let numQuestionsCorrect = result.correct_questions;
        let numQuestionsIncorrect = result.incorrect_questions;
        let questionPercent = numQuestionsCorrect * 100 / numQuestionsAnswered;

        let template = Handlebars.compile($("#reviewQuestionResultModal").html());
        let context = {
            category: this.categoryInfo,
            points: points,
            percent: questionPercent,
            num_questions_answered: numQuestionsAnswered,
            num_questions_correct: numQuestionsCorrect,
            num_questions_incorrect: numQuestionsIncorrect
        };
        $("#modalContainer").html(template(context)).modal('show');
        $('#resumen-partido').attr('data-dimension', $(window).width() <= 420 ? '138' : '188');
        $('#resumen-partido').circliful();

    };

}